"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scoreColor = void 0;
const ChartingPalette_1 = __importDefault(require("@opsbase/lib-palette/ChartingPalette"));
const scorePalette = ChartingPalette_1.default.generatePalette(30);
const scoreColor = (value) => {
    if (value < 20)
        return scorePalette[7];
    if (value < 40)
        return scorePalette[8];
    if (value < 60)
        return scorePalette[9];
    if (value < 80)
        return scorePalette[10];
    return scorePalette[11];
};
exports.scoreColor = scoreColor;
exports.default = exports.scoreColor;
